import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoublesliderComponent } from './doubleslider.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from '@app/directives/directive.module';

@NgModule({
    declarations: [
        DoublesliderComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        DirectiveModule,
        ReactiveFormsModule
    ],
    exports: [
        DoublesliderComponent
    ]
})
export class DoublesliderModule { }
